// src/components/FlightForm.tsx
import { useState, useEffect } from 'react';
import { Input, Button, Stack } from '@chakra-ui/react';

interface FlightFormProps {
    initialData?: any;
    onSubmit: (data: any) => void;
}

const FlightForm: React.FC<FlightFormProps> = ({ initialData, onSubmit }) => {
    const [formData, setFormData] = useState({
        airline: '',
        from: '',
        to: '',
        departureDate: '',
        returnDate: '',
        price: '',
        passengers: '',
        class: 'Economy',
    });

    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        }
    }, [initialData]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        const userId = localStorage.getItem('userId');
        onSubmit({ ...formData, userId });
    };

    return (
        <Stack spacing={3}>
            <Input name="airline" placeholder="Airline" value={formData.airline} onChange={handleChange} />
            <Input name="from" placeholder="From" value={formData.from} onChange={handleChange} />
            <Input name="to" placeholder="To" value={formData.to} onChange={handleChange} />
            <Input name="departureDate" placeholder="Departure Date" type="date" value={formData.departureDate} onChange={handleChange} />
            <Input name="returnDate" placeholder="Return Date" type="date" value={formData.returnDate} onChange={handleChange} />
            <Input name="price" placeholder="Price" type="number" value={formData.price} onChange={handleChange} />
            <Input name="passengers" placeholder="Passengers" type="number" value={formData.passengers} onChange={handleChange} />
            <Input name="class" placeholder="Class" value={formData.class} onChange={handleChange} />
            <Button onClick={handleSubmit}>Submit</Button>
        </Stack>
    );
};

export default FlightForm;
